import { useEffect } from "react";
import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";
import StripSection from "./components/StripSection";
import LocationBenefits from "./components/LocationBenefits";

function App() {
  const project = "Siddha Sky, Wadala";
  const galleryImages = [
    {
      src: "images/g1.jpg",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/g2.jpg",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/g3.jpg",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/g4.jpg",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/g5.jpg",
      alt: "gallery5",
      title: "gallery5",
    },
    {
      src: "images/g6.jpg",
      alt: "gallery6",
      title: "gallery6",
    },
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/a1.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a2.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a3.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a4.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a5.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a6.jpg",
      alt: "amenities",
      title: "amenities",
    },
    {
      src: "images/a7.jpg",
      alt: "amenities",
      title: "amenities",
    },
  ];

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "c"))
      ) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty array means it runs once on mount
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <NewForm />
        <StripSection />
        <Details project={project} />
        <Pricing project={project} />
        <FloorPlan project={project} />
        <Slider project={project} title="Amenities" images={amenityImages} />
        <Slider project={project} title="Gallery" images={galleryImages} />
        <LocationBenefits project={project} />
        <AboutDeveloper project={project} />
        {/* <AboutCapitalAcres /> */}
        <BestQuotes />
        <Footer />
        <Form />
      </div>
    </>
  );
}

export default App;
